import { IMAGE_MAX_SIZE, IMAGE_ALLOWED_TYPES } from '../config/constants.js';
import { devLog, devError } from './logger.js';
import { buildApiUrl } from './apiBase.js';

/**
 * 画像アップロード用ユーティリティ（API 経由）
 */

export function validateImageFile(file) {
  if (!file) {
    return { valid: false, error: 'ファイルが選択されていません' };
  }

  if (file.size > IMAGE_MAX_SIZE) {
    const sizeMB = IMAGE_MAX_SIZE / 1024 / 1024;
    return { valid: false, error: `ファイルサイズは${sizeMB}MB以下にしてください` };
  }

  if (!IMAGE_ALLOWED_TYPES.includes(file.type)) {
    return { valid: false, error: '対応している画像形式: JPEG, PNG, GIF, WebP' };
  }

  return { valid: true, error: null };
}

/**
 * クリニックロゴを API 経由でアップロード
 */
export async function uploadClinicLogo(clinicId, file) {
  const validation = validateImageFile(file);
  if (!validation.valid) {
    throw new Error(validation.error);
  }

  try {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await fetch(buildApiUrl(`/api/admin/clinics/${clinicId}/logo`), {
      method: 'POST',
      credentials: 'include',
      body: formData
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.message || 'ロゴのアップロードに失敗しました');
    }

    devLog('クリニックロゴアップロード完了:', data.logoUrl);
    return data.logoUrl;
  } catch (error) {
    devError('クリニックロゴアップロードエラー:', error);
    throw new Error('画像のアップロードに失敗しました: ' + error.message);
  }
}

/**
 * ユーザーアバター（将来用・未実装 API）
 */
export async function uploadUserAvatar(userId, file) {
  const validation = validateImageFile(file);
  if (!validation.valid) {
    throw new Error(validation.error);
  }
  throw new Error('ユーザーアバターアップロードは API 未実装です');
}

/**
 * 画像削除はサーバー側クリニック更新時に処理
 */
export async function deleteImage() {
  devLog('deleteImage: API 一本化のためクライアントからは呼び出し不要');
}

export function getImagePreviewUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
